import { render } from "./Rule.vue?vue&type=template&id=617e3673&scoped=true"
import script from "./Rule.vue?vue&type=script&lang=js"
export * from "./Rule.vue?vue&type=script&lang=js"

import "./Rule.vue?vue&type=style&index=0&id=617e3673&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\17630037586\\Desktop\\新建文件夹 (2)\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617e3673"]])

export default __exports__